<template>
  <v-checkbox
    v-if="!switchMode"
    v-model="model"
    :label="required ? '*' + label : label"
    :name="fieldKey"
    :hint="hint"
    :error-messages="errorMessages"
    color="secondary"
    :disabled="disabled"
    :hide-details="!Boolean(hint) && ! Boolean(errorMessages)"
  />
  <v-switch
    v-else
    v-model="model"
    :label="required ? '*' + label : label"
    :name="fieldKey"
    :hint="hint"
    :error-messages="errorMessages"
    color="secondary"
    :disabled="disabled"
    :hide-details="!Boolean(hint) && ! Boolean(errorMessages)"
  />
</template>

<script>
  import InputMixin from './InputMixin'

  export default {
    mixins: [InputMixin],
    props: {
      modelValue: Boolean,
      label: {
        type: String,
        default: ''
      },
      switchMode: Boolean,
      not: Boolean
    },
    emits: ['update:model-value'],
    data: () => ({
      model: false
    }),
    watch: {
      model () {
        if (this.not) {
          this.$emit('update:model-value', !this.model)
        } else {
          this.$emit('update:model-value', this.model)
        }
      }
    },
    created() {
      this.model = this.not ? !this.modelValue : this.modelValue
    }
  }
</script>
